import * as service from './custom_readings.service.js'
export default {
  data() {
    return {
      lastreadingname: '',
      customChemReadings: [{
        "Id": 0,
        "Name": "",
        "Description": "",
        "Low": '',
        "IdealLow": '',
        "IdealHigh": '',
        "High": '',
        "UoM": "",
        "IsCustom": true,
        "IsActive": true,
        "DecimalMarker":0
      }],
      //FG - FOOF - Jan 6 2019 - added the array below to hold the non-custom chemical readings
      //  (that is, those delivered from Hydroware)
      deliveredChemReadings: [this.getIntializedCustomChemReading()],
      readingForm: [],
      UOM: []
    }
  },
  mounted() {
    this.UOM = ["PPM"]
    let context = this
    this.GetAllCustomLogReadings()

    //FG - FOOF - Jan 6 2018 - added line below to get the delivered chem readings
    this.GetAllDeliveredLogReadings()
  },
    methods: {
    /********************************************************************************** */
    //FG - FOOF - Jan 6 2019 - added methods below to check for duplicate name as soon
    //  as the name field loses focus.
    customReadingNameHasBeenBlurred(ev) {
      var context = this
      var deliveredReadingErrMsg = " cannot be used.  It duplicates a delivered reading."
      var customReadingErrMsg = " cannot be used.  It duplicates another custom reading."
      var errMsgToDisplay = '';
      var srcElement = ev.srcElement;
      var readingNameTrimmed = srcElement.value.trim();
      //First see if the reading name is in the delivered list of reading names
      //If it is then we set the error message that will be displayed and we don't have to check any further
      if(this.isReadingNameInDeliveredReadings(readingNameTrimmed)) {
        errMsgToDisplay = deliveredReadingErrMsg;
      }
      else {//The reading name is not in the delivered list, but is it already in the custom list ?
        if(this.isReadingNameInCustomReadings(readingNameTrimmed))
          errMsgToDisplay = customReadingErrMsg
      }
      //If the reading name is a duplicate (either in delivered list or custom list)
      //then the errMsgToDisplay will not be an empty string so we display it.
      if(errMsgToDisplay != '') {
        if(context.lastreadingname =='' || context.lastreadingname.trim() != readingNameTrimmed) {
          context.lastreadingname = readingNameTrimmed
          this.$notify({
            title: 'Duplicate',
            message: readingNameTrimmed + errMsgToDisplay,
            type: 'error'
          })
        }
        $(ev.srcElement).addClass('hydroware_error_border')
        this.$nextTick(() => $(ev.srcElement).focus())
      }
      else {
        context.lastreadingname = ''
        $(ev.srcElement).removeClass('hydroware_error_border')
      }
    },
    isReadingNameInDeliveredReadings(readingName) {
      var readingNameTrimmedEtc = readingName.trim().toLowerCase();
      for(var i=0;i<this.deliveredChemReadings.length;i++) {
        if(readingNameTrimmedEtc == this.deliveredChemReadings[i].Name.trim().toLowerCase())
          return true;
      }
      return false;
   },
   
 isReadingNameInCustomReadings(readingName) {
  var readingNameTrimmedEtc = readingName.trim().toLowerCase();
  var readingNameCount = 0; //FG - FOOF - Jan 9 2019 - count of the reading names that match the passed in name
  for(var i=0;i<this.customChemReadings.length;i++) {
    if(readingNameTrimmedEtc == this.customChemReadings[i].Name.trim().toLowerCase()) {
      readingNameCount++
      if(readingNameCount > 1)  //FG - FOOF - if there is a duplicate return true
        return true;
    }
  }
  return false; //NO DUP IN THE CUSTOM READINGS
},
    //FG - FOOF - After Cert - First Release Security
    shouldReadingBeDisabled(id, readingName) {
      //The id will only be zero (the null is really not needed but...) 
      //then the reading name being checked has to be from an add.
      //If the row was added then the person who added it should have the
      //opportunity to modify it before doing the update to the database
      //therefore any reading with an id of 0 will NOT be disabled.     
      if(id == null || id == 0) return false;
      //For rows with id > 1 we need to be sure the user is allowed to edit 
      //return !this.$hydrowareSecurityJS.canEdit_A('managecustomreadings'); 
      //FG - FOOF - After Cert - First Release Security - custom settings controlled by managetemplates for this release
      return !this.$hydrowareSecurityJS.canEdit_A('managetemplates');
    },
    //FG - FOOF - After Cert - First Release Security
    shouldDeleteBeDisplayed(id, readingName) {
      //The id will only be zero (the null is really not needed but...) 
      //then the reading name being checked has to be from an add.
      //If the row was added then the person who added it should have the
      //opportunity to removed it before doing the update to the database
      //therefore any reading with an id of 0 will display the delete button.     
      if(id == null || id == 0) return true;
      //For rows with id > 1 we need to be sure the user is allowed to delete 
      //return this.$hydrowareSecurityJS.canDelete_A('managecustomreadings');
      //FG - FOOF - After Cert - First Release Security - custom settings controlled by managetemplates for this release
      return !this.$hydrowareSecurityJS.canDelete_A('managetemplates');
    },
    //FG - FOOF - create and return an initialized custom reading
    getIntializedCustomChemReading() {
      return {
        "Id": 0,
        "Name": "",
        "Description": "",
        "Low": '',
        "IdealLow": '',
        "IdealHigh": '',
        "High": '',
        "UoM": "",
        "IsCustom": true,
        "IsActive": true,
        "DecimalMarker":0
      }
    },

    //FG - FOOF - The method below adds a line to the table that is displayed on the page
    //  it does not add a reading to the database
    AddReadings(position) {
      if(position == 'top') {
        this.customChemReadings.unshift(this.getIntializedCustomChemReading())
      }
      else {
        this.customChemReadings.push(this.getIntializedCustomChemReading())
      }
    },

    //FG - FOOF - The method below adds the readings to the database
    updateRecord() {
      let context = this
      loader.startLoader()
      service.AddLogReadings(context.customChemReadings).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        context.GetAllCustomLogReadings();//FG - FOOF - After Cert - First Release (6) - get the readings so the id's are correct in the table
        loader.stopLoader()
        context.$notify({
          title: 'Success',
          message: 'Updated Readings',
          type: 'success'
        })
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    deleteReading(index, item) {
      let context = this
      var ID = item.Id
      var opts = {message: 'Are you sure you want to delete ' + item.Name + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteReadingRow.bind(null,ID,index))
    },
    deleteReadingRow(ID,index) {
      let context = this;
      if (ID == 0) { //Rows with an ID of zero have not yet been uploaded so they only need to be removed from the HTML Table
        context.customChemReadings.splice(index, 1)
        return
      }
      loader.startLoader()
      service.DeleteLogReadings(ID).then(function (response) {


        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          loader.stopLoader()
          return;
        }

        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
        context.customChemReadings.splice(index, 1)
        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },
    GetAllCustomLogReadings() {
      let context = this
      loader.startLoader()
      service.GetAllCustomLogReadings().then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          context.customChemReadings = []
          context.deliveredChemReadings = []
          loader.stopLoader()
          return;
        }

        if (response) {
          if (response.length > 0) {            
            context.customChemReadings = response            
          }
        } else {
          //context.customChemReadings = []
        }
        loader.stopLoader();
      }, (error) => {
      loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
    //FG - FOOF - Jan 6 2019 - added function below to get the delivered readings
    //  this was done when I added code for better duplicate checking
    GetAllDeliveredLogReadings() {
      let context = this
      loader.startLoader()
      service.GetAllDeliveredLogReadings().then(function (response) {
        
        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) { 
          context.customChemReadings = []
          context.deliveredChemReadings = []
          loader.stopLoader()
          return;
        }

        loader.stopLoader()
        if (response) {
          if (response.length > 0) {
            context.deliveredChemReadings = response
          }
        } else {
          //context.deliveredChemReadings = []
        }
      }, (error) => {

      loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomReadings/custom_readings.controller.js